<template>
  <div>
    <v-toolbar flat style="margin-left: -10px;padding: 0 85px 0 0;background-color:transparent;">
      <v-toolbar-title><h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px"><v-icon style="font-size: 20px;">mdi-mdi-message-text-outline</v-icon> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('menuType.dviewcontentMessages') }}&nbsp;&nbsp;&nbsp;&nbsp;</h5></v-toolbar-title>
      <v-divider vertical  style="margin: 0 10px 0 10px;"/>
      <!-- <template>        
        <v-btn-toggle
          v-model="icon" 
          @change="handleChangeIsModified"
        > 
          <v-btn :value="'mdi-information'" @click="content.FormIcon = 'mdi-information'" text>
            <v-icon>mdi-information</v-icon>
          </v-btn>
          <v-btn :value="'mdi-file-document-edit'" @click="content.FormIcon = 'mdi-file-document-edit'" text>
            <v-icon>mdi-file-document-edit</v-icon>
          </v-btn>
          <v-btn :value="'mdi-silverware-fork-knife'" @click="content.FormIcon = 'mdi-silverware-fork-knife'" text>
            <v-icon>mdi-silverware-fork-knife</v-icon>
          </v-btn>
        </v-btn-toggle>
      </template> -->
    </v-toolbar>
    <v-layout wrap>
      <v-flex xs4 text-right style="padding-right: 20px">
        Título
      </v-flex>
      <v-flex xs8>
        <custom-color-picker
          :width="'180px'"
          :icon="'mdi-format-color-fill'"
          :color="content.DviewcontentMessagesTitleColor"
          :onChangeColor="handleChangeTitleColor"
        />
      </v-flex>
      <v-flex xs4 text-right style="margin-top:20px;padding-right: 20px">
        Descripción
      </v-flex>
      <v-flex xs8 style="margin-top:20px;">
        <custom-color-picker
          :width="'180px'"
          :icon="'mdi-format-color-fill'"
          :color="content.DviewcontentMessagesDescriptionColor"
          :onChangeColor="handleChangeDescriptionColor"
        />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import api from '@/services/api'
  import Translate from '@/components/Translate'
  import CustomColorPicker from '@/components/CustomColorPicker'
  import Timetable from '@/components/timetable/Index'
  export default {
    components: {
      Translate,
      CustomColorPicker,
      Timetable
    },
    props: {
      content: {
        type: Object,
        required: true
      },
    },
    data: () => ({
      icon: null,
      forms: null,
    }),
    computed: {
      ...mapState('app',['collapseContent']),
      languages () {
        return this.$store.state.app.Languages
      },
      enterpriseID () {
        return this.$store.state.app.enterpriseID
      },
    },
    mounted () {
    },
    methods: {
      handleChangeTitleColor (v) {
        this.content.DviewcontentMessagesTitleColor = v
        this.handleChangeIsModified()
      },
      handleChangeDescriptionColor (v) {
        this.content.DviewcontentMessagesDescriptionColor = v
        this.handleChangeIsModified()
      },
      handleChangeIsModified () {
        this.$store.state.app.isModified = true
      }
    }
  }
</script>
